import type { PricePoint, PricedPricing } from "~/lib/api";

export const DEFAULT_CURRENCY = "CAD";

export const CURRENCIES = [
  { value: "JPY", label: "¥ JPY" },
  { value: "CAD", label: "$ CAD" },
  { value: "EUR", label: "€ EUR" },
  { value: "CHF", label: "CHF" },
  { value: "BGN", label: "лв BGN" },
  { value: "USD", label: "$ USD" },
  { value: "GBP", label: "£ GBP" },
  { value: "AUD", label: "$ AUD" },
  { value: "NZD", label: "$ NZD" },
  { value: "THB", label: "฿ THB" },
  { value: "KRW", label: "₩ KRW" },
  { value: "TWD", label: "$ TWD" },
  { value: "IDR", label: "Rp IDR" },
  { value: "MYR", label: "RM MYR" },
  { value: "NOK", label: "kr NOK" },
  { value: "SEK", label: "kr SEK" },
];

export function addPrice(
  pricing: PricedPricing | null | undefined,
  currency: string,
  point: PricePoint,
): PricedPricing {
  return { currency, prices: [...(pricing?.prices ?? []), point] };
}

export function updatePrice(pricing: PricedPricing, index: number, point: PricePoint): PricedPricing {
  return { ...pricing, prices: pricing.prices.map((p, i) => (i === index ? point : p)) };
}

export function removePrice(pricing: PricedPricing, index: number): PricedPricing {
  return { ...pricing, prices: pricing.prices.filter((_, i) => i !== index) };
}

export function parsePricePoint(state: Record<string, string>, type: string): PricePoint | null {
  if (!state.amount?.trim()) return null;
  const amount = parseFloat(state.amount);
  if (isNaN(amount) || amount <= 0) return null;
  const label = state.label?.trim();
  return label ? { type, label, amount } : { type, amount };
}
